import type { TOC } from '@ember/component/template-only';
import type { EmberChangeset } from 'ember-changeset';
import Dropdown from 'ui-kit/components/changeset/dropdown';
import { array, concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';

interface Signature {
  Args: {
    changeset: EmberChangeset;
  };
}
const MaritalStatusDropdownComponent: TOC<Signature> = <template>
  <Dropdown
    @labelName='Statut marital'
    @propertyName='maritalStatus'
    @changeset={{@changeset}}
    as |dropdown|
  >
    {{#each (array 'single' 'couple' 'separated' 'widowed') as |key|}}
      <dropdown.Item
        @value={{t (concat 'lifestyle.marital-status.' key)}}
        @key={{key}}
      />
    {{/each}}
  </Dropdown>
</template>;

export default MaritalStatusDropdownComponent;
